import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/UsersPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/users'

const RouteUsers = props => (
  <Fragment>
    <h3>Users</h3>
    <PaginatedConnectionTable {...props} fields={fields} showNew />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'users'
})(RouteUsers)



// WEBPACK FOOTER //
// ./src/routes/admin/users/index.js